import { render, staticRenderFns } from "./novo-usuario.vue?vue&type=template&id=e1a372dc&scoped=true&"
import script from "./novo-usuario.vue?vue&type=script&lang=js&"
export * from "./novo-usuario.vue?vue&type=script&lang=js&"
import style0 from "./novo-usuario.vue?vue&type=style&index=0&id=e1a372dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a372dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})
